import React from "react";
import { Box } from "@mui/material";
import { ParlorDetailProps } from "../../../types";
import { ColorSystemProps } from "../../../constants";

export function EstimateSection({
  defaultParlor,
  mainColor,
}: {
  defaultParlor: ParlorDetailProps;
  mainColor: ColorSystemProps;
}) {
  const expected = (defaultParlor as any).expected_charge_sum || {};
  const mubinso = expected["무빈소"] || 0;
  const gajok = expected["가족장"] || 0;
  const ilban = expected["일반장"] || 0;
  const man = (n: number) => Math.round(n / 10000);

  if (!mubinso && !gajok && !ilban) return null;

  const cards = [
    mubinso && { kind: "무빈소 (직접장)", amount: mubinso, note: "빈소를 차리지 않고 안치·입관·화장 중심. 최소 비용 구성." },
    gajok && { kind: "가족장", amount: gajok, note: "가까운 친지 중심의 작은 규모. 일반실 + 3일 장례 기준." },
    ilban && { kind: "일반장", amount: ilban, note: "조문객 응대, 음식·의전 풀세트 포함. 3일 기준." },
  ].filter(Boolean) as { kind: string; amount: number; note: string }[];

  return (
    <Box padding="0 20px 56px">
      <Box
        style={{
          background: "#252525",
          color: "#fff",
          borderRadius: "16px",
          padding: "40px 24px",
        }}
      >
        <Box
          component="h2"
          style={{ fontSize: "24px", fontWeight: 700, color: "#fff" }}
        >
          조문객 규모별 예상 비용
        </Box>
        <Box
          component="p"
          style={{ color: "#b9b9b9", marginTop: "14px", fontSize: "16px", lineHeight: 1.75, maxWidth: "640px" }}
        >
          {defaultParlor.companyname} 기준, 상조상품 적용 여부와 조문 규모에 따른 예상 비용입니다.
        </Box>
        <Box
          style={{
            marginTop: "32px",
            display: "grid",
            gridTemplateColumns: "1fr",
            gap: "12px",
          }}
          sx={{ "@media (min-width: 640px)": { gridTemplateColumns: `repeat(${cards.length}, 1fr)`, gap: "16px" } }}
        >
          {cards.map((card, i) => (
            <Box
              key={i}
              style={{
                background: "rgba(255,255,255,.04)",
                border: "1px solid rgba(255,255,255,.08)",
                borderRadius: "12px",
                padding: "24px",
              }}
            >
              <Box style={{ fontSize: "13px", color: "#b9b9b9", fontWeight: 600, letterSpacing: "0.04em" }}>
                {card.kind}
              </Box>
              <Box style={{ marginTop: "8px", fontSize: "28px", fontWeight: 700, letterSpacing: "-0.02em", color: "#fff" }}>
                {man(card.amount).toLocaleString()}
                <Box component="small" style={{ fontSize: "15px", fontWeight: 600, color: mainColor.c200, marginLeft: "4px" }}>
                  만원~
                </Box>
              </Box>
              <Box style={{ marginTop: "8px", fontSize: "13px", color: "#b9b9b9", lineHeight: 1.6 }}>
                {card.note}
              </Box>
            </Box>
          ))}
        </Box>
        <Box
          style={{
            marginTop: "24px",
            fontSize: "13px",
            color: "#b9b9b9",
            lineHeight: 1.7,
            paddingTop: "20px",
            borderTop: "1px solid rgba(255,255,255,.08)",
          }}
        >
          ※ 위 금액은 빈소 사용료 + 안치·입관·수시·쓰레기 수거 등 장례식장 기본 지출을 합산한 추정치입니다.
          상조상품(제단·수의·의전·음식)과 운구·화장장 비용은 선택에 따라 가감됩니다.
        </Box>
      </Box>
    </Box>
  );
}
